import React, { useState } from "react";
import { Form, Button, Image, Modal, Label } from "semantic-ui-react";

const AddPlayerModal = ({ onSubmit, balls, limits }) => {
  const [amount, setAmount] = useState("");
  const [open, setOpen] = useState(false);

  function _isNotValid() {
    return !balls.length;
  }

  function _onSubmit(amount) {
    onSubmit(amount);
    handleClose();
    setAmount("");
  }

  function _onChange(e) {
    const { value } = e.currentTarget;
    setAmount(value);
  }

  const handleClose = () => {
    setOpen(false);
    setAmount("");
  };

  return (
    <Modal
      className="keno-modal keno-modal--amount"
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      trigger={
        <input
          type="button"
          disabled={_isNotValid()}
          onClick={() => setOpen(true)}
          className="btn"
          value="+"
        />
      }
    >
      <Modal.Header>Ajouter une mise</Modal.Header>
      <Modal.Content image>
        <Image wrapped size="medium" src="/static/images/girl.png" />
        <Modal.Description>
          <Form
            size="huge"
            onSubmit={(e) => {
              e.preventDefault();
              _onSubmit(amount);
            }}
          >
            <Form.Field>
              <input
                type="number"
                placeholder="Amount"
                value={amount}
                name="amount"
                onChange={_onChange}
                min={limits?.minBet}
                max={limits?.maxBet}
                required
              />
              <Label
                className="keno-label"
                pointing
              >{`Veuillez saisir un montant de ${limits?.minBet} à ${limits?.maxBet} HTG`}</Label>
            </Form.Field>
            <Button type="submit" className="keno-btn">
              Ok
            </Button>
          </Form>
        </Modal.Description>
      </Modal.Content>
    </Modal>
  );
};
export default AddPlayerModal;
